<template>
  <div class="page-404">
    <div class="card">
      <div class="code">404</div>
      <div class="desc">抱歉，您访问的页面不存在</div>
      <div class="actions">
        <el-button type="primary" @click="$router.replace('/')">返回首页</el-button>
        <el-button @click="$router.go(-1)">返回上一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.page-404 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-body);
}
.card {
  text-align: center;
  background: var(--bg-card);
  padding: 48px 64px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.code {
  font-size: 64px;
  font-weight: 800;
  color: #409eff;
  line-height: 1;
  margin-bottom: 24px;
}
.desc {
  font-size: 18px;
  color: var(--text-regular);
  margin-bottom: 32px;
}
.actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}
</style>
